import { IReactBaseProps } from '@gcl/react-core';
import * as React from 'react';
import { generatePath, Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

export interface IRedirectProps extends IReactBaseProps {
  fromPath: string;
  toPath: string;
}

export const Redirect: React.FC<IRedirectProps> = ({ fromPath, toPath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();
  React.useEffect(() => {
    const pathnameTrimLastSlash = location.pathname.endsWith('/')
      ? location.pathname.substring(0, location.pathname.length - 1)
      : location.pathname;
    if (toPath && encodeURI(generatePath(fromPath, params)) === pathnameTrimLastSlash) {
      navigate(generatePath(toPath, params));
    }
  }, [location, toPath]);
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <Outlet />;
};
